import 'globals';

(function($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        if ($.prototype.lightGallery) {
            $('.light-gallery').lightGallery({
                download: false,
                thumbnail: true
            });
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
